/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateRoomMatchRequest
 */
export interface UpdateRoomMatchRequest {
    /**
     * IDs of insurer rooms
     * @type {Array<number>}
     * @memberof UpdateRoomMatchRequest
     */
    insurerRoomIds?: Array<number>;
    /**
     * IDs of contractor rooms
     * @type {Array<number>}
     * @memberof UpdateRoomMatchRequest
     */
    contractorRoomIds?: Array<number>;
    /**
     * Optional note
     * @type {string}
     * @memberof UpdateRoomMatchRequest
     */
    note?: string;
}

/**
 * Check if a given object implements the UpdateRoomMatchRequest interface.
 */
export function instanceOfUpdateRoomMatchRequest(value: object): value is UpdateRoomMatchRequest {
    return true;
}

export function UpdateRoomMatchRequestFromJSON(json: any): UpdateRoomMatchRequest {
    return UpdateRoomMatchRequestFromJSONTyped(json, false);
}

export function UpdateRoomMatchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateRoomMatchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'insurerRoomIds': json['insurerRoomIds'] == null ? undefined : json['insurerRoomIds'],
        'contractorRoomIds': json['contractorRoomIds'] == null ? undefined : json['contractorRoomIds'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function UpdateRoomMatchRequestToJSON(json: any): UpdateRoomMatchRequest {
    return UpdateRoomMatchRequestToJSONTyped(json, false);
}

export function UpdateRoomMatchRequestToJSONTyped(value?: UpdateRoomMatchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'insurerRoomIds': value['insurerRoomIds'],
        'contractorRoomIds': value['contractorRoomIds'],
        'note': value['note'],
    };
}

